import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import axios from 'axios';
import DanmuImageCard from './DanmuImageCard';
import DanmuTextCard from './DanmuTextCard';
import icoclosewhite from './img/ico-closeWhite.svg';
import strings from './strings.js';

const SelectingDanmuCard = ({ stateVer, onClick, lang }) => {
    const [danmuText, setDanmuText] = useState(false);
    const [activeImageId, setActiveImageId] = useState([]);
    const [enText, setEnText] = useState([]);
    const [cnText, setCnText] = useState([]);

    // Determine primary skin color dynamically
    const primaryColor = document.body.getAttribute('data-skin') === '1' ? '#e03637' : '#3751fe';

    const fetchData = async () => {
        try {
            // Fetching activeImageId from index.json
            const indexResponse = await axios.get('https://starboxkod.com/danmu/index.json');
            const { activeImageId } = indexResponse.data;
            setActiveImageId(activeImageId);
    
            // Fetching enText from enText.txt
            const enTextResponse = await axios.get('https://starboxkod.com/danmu/enText.txt');
            const enText = enTextResponse.data.split('\n');
            setEnText(enText);
    
            // Fetching cnText from cnText.txt
            const cnTextResponse = await axios.get('https://starboxkod.com/danmu/cnText.txt');
            const cnText = cnTextResponse.data.split('\n');
            setCnText(cnText);
        } catch (error) {
            console.error('Error fetching data:', error);
            toast.error('Error fetching data. Please try again later.');
        }
    };
    

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <div className="LMAOselecting">
            <div className="mui-overlay" onClick={(e) => { e.preventDefault(); }}></div>
            

            <div className="actions-sheet2" style={{  paddingBottom: "5px", paddingTop: "5px", paddingLeft: "5px", paddingRight: "5px", left: "1vw", right: "1vw" }} onClick={(e) => { e.preventDefault(); }}>
                <div className="controlCardClose" style={{}}>
                    <a className="controlCardCloseIcon" onClick={(e) => { e.preventDefault(); onClick() }}>
                        <img src={icoclosewhite} alt="close" />
                    </a>
                </div>

                <div style={{ display: 'flex', marginRight: '20px' }}>
                    <a 
                        className="ActionPanelnorec-btn" 
                        style={{ color: danmuText ? "#7f7f7f" : primaryColor }} 
                        onClick={(e) => { e.preventDefault(); setDanmuText(false); }}
                    >
                        {lang ? strings.cn.danmuImage : strings.en.danmuImage}
                    </a>
                    <a 
                        className="ActionPanelrec-btn" 
                        style={{ color: danmuText ? primaryColor : "#7f7f7f" }} 
                        onClick={(e) => { e.preventDefault(); setDanmuText(true); }}
                    >
                        {lang ? strings.cn.danmuText : strings.en.danmuText}
                    </a>
                </div>


                <div style={{minHeight:'60vh', maxHeight:'60vh', overflowY:'auto'}}>
                <div className="danmuImageContainer" style={{ display: danmuText ? "inline" :'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '10px', overflowX: 'auto' }}>
                    {!danmuText ? (
                        activeImageId.map((imageId, index) => (
                            <DanmuImageCard key={index} imageId={imageId} onClick={() => { }} />
                        ))
                    ) : (
                        <>
                        {
                            lang ? (
                                cnText.map((text, index) => (
                                    <DanmuTextCard mode={1} key={index} text={text} onClick={() => { }} />
                                ))
                            ) :
                            (
                                enText.map((text, index) => (
                                    <DanmuTextCard mode={1} key={index} text={text} onClick={() => { }} />
                                ))
                            )
                        }
                        </>
                    )}
                </div>
                </div>
            </div>
        </div>
    );
}

export default SelectingDanmuCard;